"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _AdminProgramGroupInstitutionConfig = _interopRequireDefault(require("../model/AdminProgramGroupInstitutionConfig"));
var _AdminProgramGroupResponseBody = _interopRequireDefault(require("../model/AdminProgramGroupResponseBody"));
var _AdminProgramResponseBody = _interopRequireDefault(require("../model/AdminProgramResponseBody"));
var _AdminProgramsDeleteProgramGroupPostRequest = _interopRequireDefault(require("../model/AdminProgramsDeleteProgramGroupPostRequest"));
var _AdminProgramsDeleteProgramPostRequest = _interopRequireDefault(require("../model/AdminProgramsDeleteProgramPostRequest"));
var _AdminProgramsGetProgramGroupsInstitutionConfigPostRequest = _interopRequireDefault(require("../model/AdminProgramsGetProgramGroupsInstitutionConfigPostRequest"));
var _AdminProgramsListProgramProgressDataPost200ResponseInner = _interopRequireDefault(require("../model/AdminProgramsListProgramProgressDataPost200ResponseInner"));
var _AdminProgramsSetProgramGroupsInstitutionConfigPostRequest = _interopRequireDefault(require("../model/AdminProgramsSetProgramGroupsInstitutionConfigPostRequest"));
var _AdminProgramsSetProgramsConfigsPostRequest = _interopRequireDefault(require("../model/AdminProgramsSetProgramsConfigsPostRequest"));
var _CreateProgramGroupRequest = _interopRequireDefault(require("../model/CreateProgramGroupRequest"));
var _CreateProgramRequest = _interopRequireDefault(require("../model/CreateProgramRequest"));
var _EditProgramGroupRequest = _interopRequireDefault(require("../model/EditProgramGroupRequest"));
var _EditProgramRequest = _interopRequireDefault(require("../model/EditProgramRequest"));
var _ErrorResponse = _interopRequireDefault(require("../model/ErrorResponse"));
var _ProgramConfig = _interopRequireDefault(require("../model/ProgramConfig"));
var _ProgramsUpdateProgramProgressPost200Response = _interopRequireDefault(require("../model/ProgramsUpdateProgramProgressPost200Response"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Manage My Pain API
 * This document provide full documentation for [ManagingLife](http://managinglife.com) API # Introduction Each API call only supports POST calls, and all parameters goes to body of POST request<br> Format of each API endpoint is `https://SERVER.managinglife.com/api/vVERSION/SERVICE/METHOD`   - **SERVER** could be one of: *dev*, *preprod*, *sync*.   - **VERSION** could be one of: *1*, *3*, *4*.   - **SERVICE** e.g. *core*, *sync*, *alerts*.   - **METHOD** e.g. *generate-report*, *login-user*, *update-records*.  Any parameter that is not marked as required can be null or omitted. # Client libraries We also provide several client libraries which were auto-generated using swagger-codegen.   - [JavaScript](/codegen/javascript)   - [Java](/codegen/java)   - [PHP](/codegen/php)   - [Objective C](/codegen/objc) # Authentication <!-- ReDoc-Inject: <security-definitions> --> 
 *
 * The version of the OpenAPI document: 4.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* AdminPrograms service.
* @module api/AdminProgramsApi
* @version 4.0.0
*/
var AdminProgramsApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new AdminProgramsApi. 
  * @alias module:api/AdminProgramsApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function AdminProgramsApi(apiClient) {
    _classCallCheck(this, AdminProgramsApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * create-program-group
   * Create a new program group
   * @param {Object} opts Optional parameters
   * @param {module:model/CreateProgramGroupRequest} [CreateProgramGroupRequest] 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AdminProgramGroupResponseBody} and HTTP response
   */
  return _createClass(AdminProgramsApi, [{
    key: "adminProgramsCreateProgramGroupPostWithHttpInfo",
    value: function adminProgramsCreateProgramGroupPostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['CreateProgramGroupRequest'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _AdminProgramGroupResponseBody["default"];
      return this.apiClient.callApi('/admin-programs/create-program-group', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * create-program-group
     * Create a new program group
     * @param {Object} opts Optional parameters
     * @param {module:model/CreateProgramGroupRequest} opts.CreateProgramGroupRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AdminProgramGroupResponseBody}
     */
  }, {
    key: "adminProgramsCreateProgramGroupPost",
    value: function adminProgramsCreateProgramGroupPost(opts) {
      return this.adminProgramsCreateProgramGroupPostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * create-program
     * Creates program with params specified
     * @param {Object} opts Optional parameters
     * @param {module:model/CreateProgramRequest} [CreateProgramRequest] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AdminProgramResponseBody} and HTTP response
     */
  }, {
    key: "adminProgramsCreateProgramPostWithHttpInfo",
    value: function adminProgramsCreateProgramPostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['CreateProgramRequest'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _AdminProgramResponseBody["default"];
      return this.apiClient.callApi('/admin-programs/create-program', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * create-program
     * Creates program with params specified
     * @param {Object} opts Optional parameters
     * @param {module:model/CreateProgramRequest} opts.CreateProgramRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AdminProgramResponseBody}
     */
  }, {
    key: "adminProgramsCreateProgramPost",
    value: function adminProgramsCreateProgramPost(opts) {
      return this.adminProgramsCreateProgramPostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * delete-program-group
     * Deletes existing program group
     * @param {Object} opts Optional parameters
     * @param {module:model/AdminProgramsDeleteProgramGroupPostRequest} [AdminProgramsDeleteProgramGroupPostRequest] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response} and HTTP response
     */
  }, {
    key: "adminProgramsDeleteProgramGroupPostWithHttpInfo",
    value: function adminProgramsDeleteProgramGroupPostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['AdminProgramsDeleteProgramGroupPostRequest'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ProgramsUpdateProgramProgressPost200Response["default"];
      return this.apiClient.callApi('/admin-programs/delete-program-group', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * delete-program-group
     * Deletes existing program group
     * @param {Object} opts Optional parameters
     * @param {module:model/AdminProgramsDeleteProgramGroupPostRequest} opts.AdminProgramsDeleteProgramGroupPostRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response}
     */
  }, {
    key: "adminProgramsDeleteProgramGroupPost",
    value: function adminProgramsDeleteProgramGroupPost(opts) {
      return this.adminProgramsDeleteProgramGroupPostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * delete-program
     * Delete program by id
     * @param {Object} opts Optional parameters
     * @param {module:model/AdminProgramsDeleteProgramPostRequest} [AdminProgramsDeleteProgramPostRequest] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response} and HTTP response
     */
  }, {
    key: "adminProgramsDeleteProgramPostWithHttpInfo",
    value: function adminProgramsDeleteProgramPostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['AdminProgramsDeleteProgramPostRequest'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ProgramsUpdateProgramProgressPost200Response["default"];
      return this.apiClient.callApi('/admin-programs/delete-program', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * delete-program
     * Delete program by id
     * @param {Object} opts Optional parameters
     * @param {module:model/AdminProgramsDeleteProgramPostRequest} opts.AdminProgramsDeleteProgramPostRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response}
     */
  }, {
    key: "adminProgramsDeleteProgramPost",
    value: function adminProgramsDeleteProgramPost(opts) {
      return this.adminProgramsDeleteProgramPostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * edit-program-group
     * Edit existing program group
     * @param {Object} opts Optional parameters
     * @param {module:model/EditProgramGroupRequest} [EditProgramGroupRequest] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AdminProgramGroupResponseBody} and HTTP response
     */
  }, {
    key: "adminProgramsEditProgramGroupPostWithHttpInfo",
    value: function adminProgramsEditProgramGroupPostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['EditProgramGroupRequest'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _AdminProgramGroupResponseBody["default"];
      return this.apiClient.callApi('/admin-programs/edit-program-group', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * edit-program-group
     * Edit existing program group
     * @param {Object} opts Optional parameters
     * @param {module:model/EditProgramGroupRequest} opts.EditProgramGroupRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AdminProgramGroupResponseBody}
     */
  }, {
    key: "adminProgramsEditProgramGroupPost",
    value: function adminProgramsEditProgramGroupPost(opts) {
      return this.adminProgramsEditProgramGroupPostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * edit-program
     * Edit program according to params specified
     * @param {Object} opts Optional parameters
     * @param {module:model/EditProgramRequest} [EditProgramRequest] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AdminProgramResponseBody} and HTTP response
     */
  }, {
    key: "adminProgramsEditProgramPostWithHttpInfo",
    value: function adminProgramsEditProgramPostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['EditProgramRequest'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _AdminProgramResponseBody["default"];
      return this.apiClient.callApi('/admin-programs/edit-program', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * edit-program
     * Edit program according to params specified
     * @param {Object} opts Optional parameters
     * @param {module:model/EditProgramRequest} opts.EditProgramRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AdminProgramResponseBody}
     */
  }, {
    key: "adminProgramsEditProgramPost",
    value: function adminProgramsEditProgramPost(opts) {
      return this.adminProgramsEditProgramPostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * get-program-body
     * This request returns program body html file attachment
     * @param {Number} program_id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link File} and HTTP response
     */
  }, {
    key: "adminProgramsGetProgramBodyGetWithHttpInfo",
    value: function adminProgramsGetProgramBodyGetWithHttpInfo(program_id) {
      var postBody = null;
      // verify the required parameter 'program_id' is set
      if (program_id === undefined || program_id === null) {
        throw new Error("Missing the required parameter 'program_id' when calling adminProgramsGetProgramBodyGet");
      }
      var pathParams = {
        'program_id': program_id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['text/html', 'application/json'];
      var returnType = File;
      return this.apiClient.callApi('/admin-programs/get-program-body', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * get-program-body
     * This request returns program body html file attachment
     * @param {Number} program_id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link File}
     */
  }, {
    key: "adminProgramsGetProgramBodyGet",
    value: function adminProgramsGetProgramBodyGet(program_id) {
      return this.adminProgramsGetProgramBodyGetWithHttpInfo(program_id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * get-program-groups-institution-config
     * Get an array of program group institution config objects
     * @param {Object} opts Optional parameters
     * @param {module:model/AdminProgramsGetProgramGroupsInstitutionConfigPostRequest} [AdminProgramsGetProgramGroupsInstitutionConfigPostRequest] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/AdminProgramGroupInstitutionConfig>} and HTTP response
     */
  }, {
    key: "adminProgramsGetProgramGroupsInstitutionConfigPostWithHttpInfo",
    value: function adminProgramsGetProgramGroupsInstitutionConfigPostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['AdminProgramsGetProgramGroupsInstitutionConfigPostRequest'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = [_AdminProgramGroupInstitutionConfig["default"]];
      return this.apiClient.callApi('/admin-programs/get-program-groups-institution-config', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * get-program-groups-institution-config
     * Get an array of program group institution config objects
     * @param {Object} opts Optional parameters
     * @param {module:model/AdminProgramsGetProgramGroupsInstitutionConfigPostRequest} opts.AdminProgramsGetProgramGroupsInstitutionConfigPostRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/AdminProgramGroupInstitutionConfig>}
     */
  }, {
    key: "adminProgramsGetProgramGroupsInstitutionConfigPost",
    value: function adminProgramsGetProgramGroupsInstitutionConfigPost(opts) {
      return this.adminProgramsGetProgramGroupsInstitutionConfigPostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * get-programs-configs
     * Get an array of programs configs objects
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/ProgramConfig>} and HTTP response
     */
  }, {
    key: "adminProgramsGetProgramsConfigsPostWithHttpInfo",
    value: function adminProgramsGetProgramsConfigsPostWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_ProgramConfig["default"]];
      return this.apiClient.callApi('/admin-programs/get-programs-configs', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * get-programs-configs
     * Get an array of programs configs objects
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/ProgramConfig>}
     */
  }, {
    key: "adminProgramsGetProgramsConfigsPost",
    value: function adminProgramsGetProgramsConfigsPost() {
      return this.adminProgramsGetProgramsConfigsPostWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * list-program-groups
     * Return all program groups with their programs
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/AdminProgramGroupResponseBody>} and HTTP response
     */
  }, {
    key: "adminProgramsListProgramGroupsPostWithHttpInfo",
    value: function adminProgramsListProgramGroupsPostWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_AdminProgramGroupResponseBody["default"]];
      return this.apiClient.callApi('/admin-programs/list-program-groups', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * list-program-groups
     * Return all program groups with their programs
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/AdminProgramGroupResponseBody>}
     */
  }, {
    key: "adminProgramsListProgramGroupsPost",
    value: function adminProgramsListProgramGroupsPost() {
      return this.adminProgramsListProgramGroupsPostWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * list-program-progress-data
     * Returns all programs user progress data including institution nid user assigned to
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/AdminProgramsListProgramProgressDataPost200ResponseInner>} and HTTP response
     */
  }, {
    key: "adminProgramsListProgramProgressDataPostWithHttpInfo",
    value: function adminProgramsListProgramProgressDataPostWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_AdminProgramsListProgramProgressDataPost200ResponseInner["default"]];
      return this.apiClient.callApi('/admin-programs/list-program-progress-data', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * list-program-progress-data
     * Returns all programs user progress data including institution nid user assigned to
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/AdminProgramsListProgramProgressDataPost200ResponseInner>}
     */
  }, {
    key: "adminProgramsListProgramProgressDataPost",
    value: function adminProgramsListProgramProgressDataPost() {
      return this.adminProgramsListProgramProgressDataPostWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * list-programs
     * Returns list of all programs
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/AdminProgramResponseBody>} and HTTP response
     */
  }, {
    key: "adminProgramsListProgramsPostWithHttpInfo",
    value: function adminProgramsListProgramsPostWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_AdminProgramResponseBody["default"]];
      return this.apiClient.callApi('/admin-programs/list-programs', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * list-programs
     * Returns list of all programs
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/AdminProgramResponseBody>}
     */
  }, {
    key: "adminProgramsListProgramsPost",
    value: function adminProgramsListProgramsPost() {
      return this.adminProgramsListProgramsPostWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * set-program-groups-institution-config
     * Specify an array of program group config objects for institution with given nid. It doesn't remove any config objects. So, if config object is missed for some programs, those config values stay the same.
     * @param {Object} opts Optional parameters
     * @param {module:model/AdminProgramsSetProgramGroupsInstitutionConfigPostRequest} [AdminProgramsSetProgramGroupsInstitutionConfigPostRequest] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response} and HTTP response
     */
  }, {
    key: "adminProgramsSetProgramGroupsInstitutionConfigPostWithHttpInfo",
    value: function adminProgramsSetProgramGroupsInstitutionConfigPostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['AdminProgramsSetProgramGroupsInstitutionConfigPostRequest'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ProgramsUpdateProgramProgressPost200Response["default"];
      return this.apiClient.callApi('/admin-programs/set-program-groups-institution-config', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * set-program-groups-institution-config
     * Specify an array of program group config objects for institution with given nid. It doesn't remove any config objects. So, if config object is missed for some programs, those config values stay the same.
     * @param {Object} opts Optional parameters
     * @param {module:model/AdminProgramsSetProgramGroupsInstitutionConfigPostRequest} opts.AdminProgramsSetProgramGroupsInstitutionConfigPostRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response}
     */
  }, {
    key: "adminProgramsSetProgramGroupsInstitutionConfigPost",
    value: function adminProgramsSetProgramGroupsInstitutionConfigPost(opts) {
      return this.adminProgramsSetProgramGroupsInstitutionConfigPostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * set-programs-configs
     * Specify an array of program config objects for institution with given nid. It doesn't remove any config objects. So, if config object is missed for some programs, those config values stay the same.
     * @param {Object} opts Optional parameters
     * @param {module:model/AdminProgramsSetProgramsConfigsPostRequest} [AdminProgramsSetProgramsConfigsPostRequest] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response} and HTTP response
     */
  }, {
    key: "adminProgramsSetProgramsConfigsPostWithHttpInfo",
    value: function adminProgramsSetProgramsConfigsPostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['AdminProgramsSetProgramsConfigsPostRequest'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ProgramsUpdateProgramProgressPost200Response["default"];
      return this.apiClient.callApi('/admin-programs/set-programs-configs', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * set-programs-configs
     * Specify an array of program config objects for institution with given nid. It doesn't remove any config objects. So, if config object is missed for some programs, those config values stay the same.
     * @param {Object} opts Optional parameters
     * @param {module:model/AdminProgramsSetProgramsConfigsPostRequest} opts.AdminProgramsSetProgramsConfigsPostRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response}
     */
  }, {
    key: "adminProgramsSetProgramsConfigsPost",
    value: function adminProgramsSetProgramsConfigsPost(opts) {
      return this.adminProgramsSetProgramsConfigsPostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
}();